import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.map";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// First key: loanTerm, Second key: state
export var stateAdjustments = {
  15: {
    CA: -0.001,
    CT: -0.0005,
    GA: -0.0005,
    HI: -0.001,
    IL: -0.001,
    MA: -0.0005,
    NE: -0.0005,
    OR: -0.0005,
    VA: -0.0005,
    AK: 0.001,
    ND: 0.001
  },
  30: {
    CA: -0.001,
    CT: -0.0005,
    GA: -0.0005,
    HI: -0.001,
    VA: -0.0005,
    ND: 0.001
  }
};
export var creditScoreRanges = [{
  text: 'Excellent',
  range: [720, 850],
  adjustment: 0
}, {
  text: 'Good',
  range: [690, 719],
  adjustment: 0.00222
}, {
  text: 'Average',
  range: [630, 689],
  adjustment: 0.01043
}, {
  text: 'Poor',
  range: [350, 629],
  adjustment: 0.01589
}].map(function (creditScoreRange) {
  return _objectSpread(_objectSpread({}, creditScoreRange), {}, {
    label: "".concat(creditScoreRange.text, " (").concat(creditScoreRange.range[0], " - ").concat(creditScoreRange.range[1], ")"),
    value: "".concat(creditScoreRange.range[0], "-").concat(creditScoreRange.range[1])
  });
});
export var defaultCreditScoreRange = creditScoreRanges[1];